/* eslint-disable max-len */
import { dwmRepository } from 'common/repositories/index';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

const _serviceDependencies = ['$scope', '$http', '$rootScope', 'Util', 'dwmValidations'];
class DwmDriversLicense {

    constructor($scope, $http, $rootScope, Util, dwmValidations) {

        $scope.driversLicenseNumberIsValid = true;

        const validations = dwmValidations;

        const onDwmDataNext = () => {

            const assets = dwmRepository.getAll('assets') || {};

            if (assets.primaryMember) {

                $scope.driversLicense = assets.primaryMember.monitoredAccounts.driversLicense;
                $scope.driversLicense.entries.forEach((entry) => {

                    entry.showUpdateInput = false;

                });

            }

        };

        const dwmRepositoryObservable = dwmRepository.getObservable();
        dwmRepositoryObservable
            .subscribe(
                data => onDwmDataNext(data),
                () => { },
                () => { },
            );

        $scope.newEntryVisible = false;
        $scope.showAddNewButton = true;
        $scope.showSaveButton = false;
        $scope.showfEntryScreen = false;
        $scope.showUpdateButton = false;

        $scope.addNewEntry = () => {

            $scope.newEntryVisible = true;
            $scope.showAddNewButton = false;
            $scope.showSaveButton = true;
            setTimeout(() => {

                angular.element('.update-drivers-license-number').trigger('focus');

            }, 100);

        };

        $scope.cancelNewEntry = () => {

            $scope.driversLicenseNumberIsValid = true;
            $scope.newEntryVisible = false;
            $scope.showAddNewButton = true;
            $scope.showSaveButton = false;
            $scope.newDriversLicenseNumber = '';
            $scope.newEntrySubmitted = false;

        };

        $scope.updateEntry = (index) => {

            $scope.newEntryVisible = false;
            $scope.showAddNewButton = false;
            $scope.showSaveButton = false;
            $scope.showUpdateButton = true;

            $scope.driversLicense.entries.forEach((entry, loopIndex) => {

                if (index === loopIndex) {

                    entry.showUpdateInput = true;
                    $scope.updateEntryPayload = entry;
                    $scope.initialDriversLicenseNumber = entry.driversLicenseNumber;
                    $scope.initialEntryIndex = loopIndex;

                } else {

                    entry.showUpdateInput = false;

                }

            });

            setTimeout(() => {

                angular.element('.update-drivers-license-number').trigger('focus');

            }, 100);

        };

        $scope.cancelUpdateNewEntry = () => {

            $scope.driversLicenseNumberIsValid = true;
            $scope.showAddNewButton = true;
            $scope.showUpdateButton = false;

            $scope.driversLicense.entries.forEach((entry) => {

                entry.showUpdateInput = false;

            });

            $scope.updateEntryPayload = {};

            // Revert changes of the selected entry
            $scope.driversLicense.entries[$scope.initialEntryIndex].driversLicenseNumber =
                $scope.initialDriversLicenseNumber;

        };

        $scope.validateDriversLicenseNumber = ($event) => {

            if ($scope.newEntrySubmitted) {

                $scope.driversLicenseNumberIsValid = $event.currentTarget.value &&
                    validations.driversLicenseNumberValidator($event.currentTarget.value.trim());

            }

            $scope.newDriversLicenseNumber = $event.currentTarget.value;

        };

        $scope.saveNewEntry = () => {

            $scope.driversLicenseNumberIsValid = $scope.newDriversLicenseNumber === undefined ? false : validations.driversLicenseNumberValidator($scope.newDriversLicenseNumber.trim());

            $scope.newEntrySubmitted = true;

            if ($scope.driversLicenseNumberIsValid) {

                $scope.saveNewDriversLicenseIsLoading = true;

                const payload = {
                    driversLicense: {
                        driversLicenseNumber: $scope.newDriversLicenseNumber,
                        type: 'OTHER',
                    },
                };
                $http({
                    method: 'POST',
                    url: `${CWCONFIG.dwm.restApi}/v1/modifyAccount`,
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json',
                    },
                    data: payload,

                }).then(() => {

                    $scope.newDriversLicenseNumber = '';
                    $scope.saveNewDriversLicenseIsLoading = false;

                    $http({
                        method: 'GET',
                        url: `${CWCONFIG.dwm.restApi}/v1/partner/members`,
                        headers: {
                            client_id: 'avira',
                            origin: 'https://avira.com',
                            access_token: $rootScope.dwmNortonToken,
                            'Content-Type': 'application/json',
                        },

                    }).then((membersResponse) => {

                        dwmRepository.replace('assets', membersResponse.data);

                        const { monitoredAccounts, dwmCardStatus } = membersResponse.data.primaryMember;
                        Mixpanel.setCommonProperty('AIA Asset Driver License', monitoredAccounts.driversLicense.entries.length);

                        Mixpanel.send('ConnectWeb AIA Entry Action Success', {
                            Action: 'Add',
                            Entry: 'Drivers license',
                        });

                        if (dwmCardStatus === 'add-more-data') {

                            $rootScope.showDwmCardHomepage = true;
                            $rootScope.showDwmAddMoreDataCard = true;

                        } else {

                            $rootScope.showDwmCardHomepage = false;

                        }

                        $scope.cancelNewEntry();

                    });

                }).catch((responseError) => {

                    $scope.saveNewDriversLicenseIsLoading = false;

                    if (responseError.data) {

                        if (responseError.data.errorCode === 4013) {

                            Alert.error('cw.dwm.dupliacte_entry_error');

                        } else if (responseError.data.errorCode === 24000) {

                            Alert.error('cw.dwm.entity.drivers_license.invalid_number');

                        } else {

                            Alert.error(
                                { message: 'cw.recommendation.error.connection_failed' },
                                {
                                    message: {
                                        brandname: CWCONFIG.partnerConfig.name,
                                        url: '/dashboard/support/tabs/support',
                                    },
                                },
                            );

                        }

                    }

                });


            }

        };

        $scope.removeEntry = (index) => {

            $scope.showRemoveEntryScreen = true;
            $scope.cancelNewEntry();

            $scope.removeEntryPayload = {
                driversLicense:
                {
                    id: $scope.driversLicense.entries[index].id,
                },
            };

        };

        $scope.confirmRemoveEntry = () => {

            $scope.confirmRemoveIsLoading = true;

            $http({
                method: 'DELETE',
                url: `${CWCONFIG.dwm.restApi}/v1/modifyAccount?payload=${encodeURIComponent(JSON.stringify($scope.removeEntryPayload))}`,
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json',
                },
            }).then(() => {

                $scope.newDriversLicenseNumber = '';

                $http({
                    method: 'GET',
                    url: `${CWCONFIG.dwm.restApi}/v1/partner/members`,
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json',
                    },

                }).then((membersResponse) => {

                    dwmRepository.replace('assets', membersResponse.data);

                    const { monitoredAccounts, dwmCardStatus } = membersResponse.data.primaryMember;
                    Mixpanel.setCommonProperty('AIA Asset Driver License', monitoredAccounts.driversLicense.entries.length);

                    Mixpanel.send('ConnectWeb AIA Entry Action Success', {
                        Action: 'Delete',
                        Entry: 'Drivers license',
                    });

                    if (dwmCardStatus === 'add-more-data') {

                        $rootScope.showDwmCardHomepage = true;
                        $rootScope.showDwmAddMoreDataCard = true;

                    } else {

                        $rootScope.showDwmCardHomepage = false;

                    }

                    $scope.confirmRemoveIsLoading = false;
                    $scope.cancelRemoveEntry();
                    $scope.cancelUpdateNewEntry();

                });

            }).catch((responseError) => {

                $scope.confirmRemoveIsLoading = false;

                if (responseError.data) {

                    Alert.error(
                        { message: 'cw.recommendation.error.connection_failed' },
                        {
                            message: {
                                brandname: CWCONFIG.partnerConfig.name,
                                url: '/dashboard/support/tabs/support',
                            },
                        },
                    );

                }

            });

        };

        $scope.cancelRemoveEntry = () => {

            $scope.showRemoveEntryScreen = false;
            $scope.removeEntryPayload = {};

        };

        $scope.updateDriversLicenseNumber = ($event) => {

            $scope.driversLicenseNumberIsValid = $event.currentTarget.value && validations.driversLicenseNumberValidator($event.currentTarget.value.trim());

            if ($scope.driversLicenseNumberIsValid) {

                $scope.updateEntryPayload.driversLicenseNumber = $event.currentTarget.value;

            }

        };

        $scope.saveUpdatedEntry = () => {

            $scope.saveUpdatedEntryIsLoading = true;

            $http({
                method: 'PUT',
                url: `${CWCONFIG.dwm.restApi}/v1/modifyAccount`,
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json',
                },
                data: { driversLicense: $scope.updateEntryPayload },
            }).then(() => {

                Mixpanel.send('ConnectWeb AIA Entry Action Success', {
                    Action: 'Update',
                    Entry: 'Drivers license',
                });

                $scope.showAddNewButton = true;
                $scope.showUpdateButton = false;
                $scope.updateEntryPayload = {};
                $scope.saveUpdatedEntryIsLoading = false;

                $http({
                    method: 'GET',
                    url: `${CWCONFIG.dwm.restApi}/v1/partner/members`,
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json',
                    },

                }).then((membersResponse) => {

                    dwmRepository.replace('assets', membersResponse.data);
                    $scope.confirmRemoveIsLoading = false;

                });

            }).catch((responseError) => {

                $scope.saveUpdatedEntryIsLoading = false;

                if (responseError.data) {

                    if (responseError.data.errorCode === 4013) {

                        Alert.error('cw.dwm.dupliacte_entry_error');

                    } else if (responseError.data.errorCode === 24000) {

                        Alert.error('cw.dwm.entity.drivers_license.invalid_number');

                    } else {

                        Alert.error(
                            { message: 'cw.recommendation.error.connection_failed' },
                            {
                                message: {
                                    brandname: CWCONFIG.partnerConfig.name,
                                    url: '/dashboard/support/tabs/support',
                                },
                            },
                        );

                    }

                }

            });

        };

    }

}

_serviceDependencies.push(DwmDriversLicense);

angular.module('controllers')
    .controller('DwmDriversLicense', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/modals/dwm/drivers-license/drivers-license.js